import { NgModule } from '@angular/core';

import {
  CoreModule,
  LoginModule,
} from '../modules.index';

import {
  WebCommonAngularJSModule,
} from 'webcommon';

const ajsComponents = [
  ...CoreModule.AjsComponents,
];

@NgModule({
  imports: [
    LoginModule,
    WebCommonAngularJSModule,
  ],
})
export class PatientPortalAngularJSModule {
  static registerAngularJS(module: angular.IModule): void {
    WebCommonAngularJSModule.registerAngularJS(module, ajsComponents);
  }
}
